export const PAID_COURSE_TYPE = 'PAID_COURSE_TYPE';
export const FREE_COURSE_TYPE = 'FREE_COURSE_TYPE';
export const SEARCH = 'SEARCH';
export const CATEGORY = 'CATEGORY';
export const SEARCHENGINE = 'SEARCHENGINE';